// Resumen de las ventas en curso que retienen apartados del SKU, del wizard.
import { useQuery } from '@tanstack/react-query';
import { sessionSummariesApi } from '@/api/services/retail-wizard/backoffice';
import { INVENTORY_QUERY_KEY } from './useInventarioLens';
import { retryUnlessClientError } from './useInventorySku';

/** Una sola consulta por juego de sesiones; sin sesiones no pide nada. */
export function useReservationSessions(sessionIds: readonly string[]) {
    return useQuery({
        queryKey: [...INVENTORY_QUERY_KEY, 'reservation-sessions', sessionIds],
        queryFn: () => sessionSummariesApi.getSummaries(sessionIds),
        enabled: sessionIds.length > 0,
        retry: retryUnlessClientError,
        staleTime: 30_000,
    });
}
